import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerOfferListPage } from '../consumer-offer-list/consumer-offer-list';
import { ConsumerOfferUserListPage } from '../consumer-offer-user-list/consumer-offer-user-list';

/**
 * Generated class for the ConsumerOfferMainPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-offer-main',
  templateUrl: 'consumer-offer-main.html',
})
export class ConsumerOfferMainPage {
	offers = ConsumerOfferListPage;
	purchasedOffers = ConsumerOfferUserListPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerOfferMainPage');
  }

}


// WEBPACK FOOTER //
// ./src/pages/consumer-offer-main/consumer-offer-main.ts